var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ev-logout" }, [
      _c("h4", [_vm._v("Logging out ... ")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }